import EmailTemplatesPage from "./EmailTemplatesPage"

export default EmailTemplatesPage
